var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.address
    ? _c(
        "div",
        [
          _c("v-layout", { staticClass: "font-weight-bold" }, [
            _vm._v("\n    " + _vm._s(_vm.address.fullName) + "\n  ")
          ]),
          _vm._v(" "),
          _vm.address.company
            ? _c("v-layout", [
                _vm._v("\n    " + _vm._s(_vm.address.company) + "\n  ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("v-layout", { attrs: { wrap: "" } }, [
            _c("span", [
              _vm._v("\n      " + _vm._s(_vm.address.address1) + "\n    ")
            ]),
            _vm._v(" "),
            _vm.address.address2
              ? _c("span", { attrs: { wrap: "" } }, [
                  _vm._v("\n      , " + _vm._s(_vm.address.address2) + "\n    ")
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("v-layout", { attrs: { wrap: "" } }, [
            _vm._v(
              "\n    " +
                _vm._s(_vm.address.city) +
                ", " +
                _vm._s(_vm.address.state) +
                " - " +
                _vm._s(_vm.address.zipCode) +
                "\n  "
            )
          ]),
          _vm._v(" "),
          _c("v-layout", { attrs: { wrap: "" } }, [
            _vm._v(
              "\n    " +
                _vm._s(_vm.address.phone) +
                " " +
                _vm._s(_vm.address.extension || "") +
                "\n  "
            )
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aa3e8e18", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa3e8e18","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LabelAddressWidget.vue
// module id = null
// module chunks = 